export default {
  currentExpandedRow: null
};



// WEBPACK FOOTER //
// ./public/pages/ListBreaks/initialState.js